import React, { useEffect, useState } from "react";
import Case from "./Case";
import { Link } from "react-router-dom";
import { services ,imgUrl} from "../utils/environments/api";

const Service1 = () => {
  const [service, setService] = useState([]);
  const [content, setContent] = useState([]);

  useEffect(() => {
    serviceData();
  }, []);


    const stats = [
    { number: "64+", label: "Projects Completed" },
    { number: "15+", label: "Team Members" },
    { number: "100%", label: "Client Satisfaction" },
  ];

  const serviceData = async () => {
    try {
      const res = await services.get("get_service_typ_api.php");
      if (res.data.data) {
        setService(res.data.data);
      } else {
        console.error("Invalid response format:", res);
      }
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };
  useEffect(() => {
    serviceContent();
  }, []);
  const serviceContent = async () => {
    try {
      const res = await services.get("get_service_typ_api.php");
      if (res.data.data) {
        setContent(res.data.data);
      } else {
        console.error("Invalid response format:", res);
      }
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };
  return (
    <div>

      {/* SERVICE TWO */}
      <div class="services-section-two margin-top">
        <div class="container">
          <div class="upper-box">
            <div class="icon-one"></div>
            <div class="icon-two"></div>
            <div class="icon-three"></div>
            {/* <!-- Sec Title --> */}
            <div class="sec-title light centered">
              <div class="title"><h2>Who We Are</h2></div>
              <div className="flexingehocontent">
                  <h2 className="service-subcontent">
                We specialize in delivering comprehensive IT services, including IoT solutions, product development, mobile and web application development, and digital marketing.
              </h2>
              </div>
            
            </div>
          </div>
          <div class="inner-container">
            <div class="row clearfix">
              {/* <!-- Service Block Two --> */}

             {service.map((item) => (
  <div className="service-block-two col-lg-4 col-md-6 col-sm-12" key={item.servicetype_id}>
    <Link to={`/Service?id=${item.servicetype_id}`}>
      <div className=" group relative overflow-hidden rounded-xl shadow-lg transition-transform duration-300 hover:-translate-y-1">
        
        {/* 🖼️ Service Image */}
        <div className="service-image w-full h-48 overflow-hidden rounded-t-xl">
          <img
            src={`${imgUrl}${item.image}`} 
            alt={item.service}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        </div>

        {/* 🧩 Card Content */}
        <div className="inner-box p-5 bg-white dark:bg-gray-800 relative z-10">
          <div className="shape-one"></div>
          <div className="shape-two"></div>
          <h5 className="text-xl font-semibold mb-2 text-gray-900 dark:text-white">
            {item.service}
          </h5>
          <div >
            <p className="cardptagcolour">{item.content}</p>
          </div>
        </div>

      </div>
    </Link>
  </div>
))}

            </div>
          </div>
        </div>
      </div>

        <div className="about-hero">
        <div className="hero-content">
          <div className="container">
            <div className="hero-text">
              <h2>Driving Digital Transformation Through Innovation</h2>
              <div className="aboutsubcontent">
                <p>
                  Vincosys is a premier technology company specializing in IoT
                  solutions, mobile applications, and web development services.
                  We transform innovative ideas into powerful digital solutions
                  that drive business growth and success.
                </p>
              </div>

              <div className="hero-stats">
                {stats.map((stat, index) => (
                  <div key={index} className="stat-item">
                    <h3>{stat.number}</h3>
                    <p>{stat.label}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Case />


     

    </div>
  );
};
export default Service1;
